<script lang="ts">
    import { onDestroy } from 'svelte';
    import { spineBus } from '$src/lib/services/gatekeeper/MessageBus';
    import { notificationStore } from '$src/lib/stores/notifications';
    import type { TChangeEvent } from '@casumo/fabric-fundamentals';

    $effect(() => {
        window.fabric.persistedState.redDot = $notificationStore;
    });

    const unsubscribe = spineBus.subscribe(
        'red-dot',
        ({ kind, data }: { kind: 'change'; data: TChangeEvent }) => {
            if (kind === 'change') {
                notificationStore.update((current) => {
                    return { ...current, [data.type]: data.status === 'on' };
                });
            }
        }
    );

    onDestroy(() => {
        unsubscribe();
    });
</script>
